// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collections-view__enable-customer-form{display:flex;max-width:20rem}", ""]);
// Exports
module.exports = exports;
